var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportTemplate',{attrs:{"permission":_vm.PERMISSION_CODES.CMS_VIEW_REPORT_CASH_MANAGEMENT,"loading":!_vm.initialized,"title":"Cash Management Report","filters":_vm.filters,"columns":_vm.columns,"fetchRoute":"/reports/cash-management","reportTypeCode":_vm.REPORT_MASTER_CODES.CASH_MANAGEMENT}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }